import { importAllImages } from "../Utils/ImportImages";

export const DataSourceIcons = importAllImages(require.context(`./DataSourceIcons`, false, /\.(png|jpe?g|svg|gif)$/));
export const Logos = importAllImages(require.context(`./Logos`, false, /\.(png|jpe?g|svg|gif)$/));
export const Flags = importAllImages(require.context(`./Flags`, false, /\.(png|jpe?g|svg|gif)$/));
